import { render, staticRenderFns } from "./SettingSystemNotificationsModal.vue?vue&type=template&id=17eea164&"
import script from "./SettingSystemNotificationsModal.vue?vue&type=script&lang=js&"
export * from "./SettingSystemNotificationsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports